import { fonts } from '../../constants/fonts';

export const loadFont = (fontType: string): void => {
  const style = document.createElement('style');
  style.innerHTML = `@import url(${fonts[fontType]})`;
  document.head.appendChild(style);
};
